//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'YandexTicketBueButton',
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    clientKey: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => 'event'
    },
    regionId: {
      type: [String, Number],
      required: true,
    },
    background: {
      type: String,
      default: () => 'var(--accent-color)'
    },
    color: {
      type: String,
      default: () => 'var(--white)'
    }
  },
  computed: {
    style () {
      return {
        background: this.background,
        color: this.color
      }
    }
  },
  methods: {
    click () {
      // eslint-disable-next-line no-undef
      YandexTicketsDealer.open({
        id: this.id,
        clientKey: this.clientKey || this.$config.yandex.tickets.key,
        type: this.type,
        regionId: this.regionId
      })
    }
  }
}
